module.exports = __webpack_public_path__ + "img/team-alisja@2x.7ff189a5.jpg";